import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const StoryProgress = ({ totalSteps, currentStep, progress }) => {
  return (
    <div className="absolute top-0 left-0 w-full z-50 flex gap-1 p-2 pt-4">
      {Array.from({ length: totalSteps }).map((_, index) => (
        <ProgressSegment 
          key={index} 
          index={index} 
          currentStep={currentStep} 
          progress={progress}
        />
      ))}
    </div>
  );
};

const ProgressSegment = ({ index, currentStep, progress }) => {
  const isPast = index < currentStep;
  const isCurrent = index === currentStep;
  
  let width = "0%";
  if (isPast) width = "100%";
  if (isCurrent) width = `${progress}%`;

  return (
    <div className="h-1 flex-1 bg-white/30 rounded-full overflow-hidden relative">
      <div 
        className="absolute top-0 left-0 h-full bg-white"
        style={{ width: width }}
      />
    </div>
  );
};

export default StoryProgress;
